import c0 from './configurations/show_controller';
import c1 from './feed_items/show_controller';
export const definitions = [
	{identifier: 'configurations--show', controllerConstructor: c0},
	{identifier: 'feed-items--show', controllerConstructor: c1},
];
